import { SnackbarProvider } from 'notistack'
import { ReactNode } from 'react'

import { NotificationBar } from './notification-bar.component'

interface IProps {
  children: ReactNode
}

export const UIContextProvider = ({ children }: IProps) => {
  return (
    <SnackbarProvider
      Components={{
        success: NotificationBar,
        warning: NotificationBar,
        error: NotificationBar,
        info: NotificationBar,
      }}
      maxSnack={3}
    >
      {children}
    </SnackbarProvider>
  )
}
